// Лёгкий клиентский роутер (без react-router): pushState + событие pm:navigate.
// Используется для мгновенного переключения Чат↔Студия без перезагрузки страницы.
import { useEffect, useState } from 'react';
export function navigate(path, opts) {
    if (path === window.location.pathname + window.location.search)
        return;
    if (opts?.replace)
        window.history.replaceState(null, '', path);
    else
        window.history.pushState(null, '', path);
    window.dispatchEvent(new Event('pm:navigate'));
}
/** Текущий pathname, реактивно (popstate + наши pushState через pm:navigate). */
export function useLocation() {
    const [path, setPath] = useState(() => window.location.pathname);
    useEffect(() => {
        const on = () => setPath(window.location.pathname);
        window.addEventListener('popstate', on);
        window.addEventListener('pm:navigate', on);
        return () => {
            window.removeEventListener('popstate', on);
            window.removeEventListener('pm:navigate', on);
        };
    }, []);
    return path;
}
